import React, { useEffect } from "react";
import { render } from "react-dom";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

import { redirectUser } from "./helpers";
import { useAuthStatus } from "./hooks";
import { LoginLayout } from "./layouts/login";
import { OnboardingLayout } from "./layouts/onboarding";
import { StoreProvider } from "./store";

import "basscss/css/basscss.css";
import "../css/custom.css";

// Used to log in the Recording Agent: https://github.com/minervaproject/recording-agent/blob/master/worker/interpreter.js#L223
require("jquery");

const LoginApp = () => {
  const [isAuthenticated, isValidatingAuth] = useAuthStatus();
  const pathsForAutoRedirectToApp = [/^\/$/, /^\/password$/, /^\/org\/.*/];
  const currentPath = window.location.pathname;
  const shouldAutoRedirectToApp = pathsForAutoRedirectToApp.some((pathRegex) =>
    pathRegex.test(currentPath),
  );

  useEffect(() => {
    if (!shouldAutoRedirectToApp) return;
    if (isAuthenticated || window.context?.masquerade) return redirectUser();
  }, [shouldAutoRedirectToApp, isAuthenticated]);

  if (isValidatingAuth || (shouldAutoRedirectToApp && isAuthenticated)) return null;

  return (
    <StoreProvider>
      <Router>
        <Switch>
          <Route path="/welcome" component={OnboardingLayout} />
          <Route path="/" component={LoginLayout} />
        </Switch>
      </Router>
    </StoreProvider>
  );
};
const appContainerElement = document.getElementById("app");

render(<LoginApp />, appContainerElement);
